export default {
  isConnected: false
}
